"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBytesCount = void 0;
const zero_x_prefix_1 = require("./zero-x-prefix");
function getBytesCount(hex) {
    return BigInt((0, zero_x_prefix_1.trim0x)(hex).length / 2);
}
exports.getBytesCount = getBytesCount;
//# sourceMappingURL=get-bytes-count.js.map